import * as React from "react";
import ReactTable from "react-table";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ResumenNovedad } from "../modelo/ConsultaNovedadesResumen";
import { FiltroConsultaReciboResumen } from "../../config_general_recibo/modelo/NovedadesRecibidas";
import { CODIGOS_CONSULTA } from "../../config_general_recibo/modelo/CodigosConsulta";
import { ModalDetalleJson } from "../../config_general/componentes/ModalDetalleJson";

export default class TablaConsultaResumen extends React.Component<TablaConsultaResumenProps, any> {

    columns = [{
        id: "consecutivo",
        Header: "Consecutivo",
        accessor: "consecutivo",
        Cell: props => (this.renderTexto(props)),
        width: 72
    }, {
        id: "consecutivoSolicitud",
        Header: "Consecutivo Ministerio",
        accessor: "consecutivoSolicitud",
        Cell: props => (this.renderTexto(props)),
        width: 250
    }, {
        id: "nombreServicio",
        Header: "Servicio",
        accessor: "nombreServicio",
        Cell: props => (this.renderTexto(props)),
        width: 250
    }, {
        id: "mensajeEnviadoSAT",
        Header: "Mensaje Recibido",
        accessor: "mensajeEnviadoSAT",
        Cell: props => (this.renderDetalleJson(props, props.original.mensajeEnviadoSAT)),
        width: 110
    }, {
        id: "mensajeRespuestaSura",
        Header: "Mensaje Respuesta",
        accessor: "mensajeRespuestaSura",
        Cell: props => (this.renderDetalleJson(props, props.original.mensajeRespuestaSura)),
        width: 110
    }, {
        id: "estructuraValida",
        Header: "Estructura Valida",
        accessor: "estructuraValida",
        Cell: props => (this.renderTexto(props)),
        width: 100
    }, {
        id: "fechaIngresaSAT",
        Header: "Fecha Ingreso",
        accessor: "fechaIngresaSAT",
        Cell: props => (this.renderTexto(props)),
        width: 130
    }, {
        id: "estado",
        Header: "Estado",
        accessor: "estado",
        Cell: props => (this.renderTexto(props)),
        width: 70
    }];

    render() {
        const { registros, paginas, tamanoPagina, paginaActual, totalRegistros } = this.props;
        let numRegistros = 0;

        if (registros.length < tamanoPagina) {
            numRegistros = registros.length;
        } else {
            numRegistros = tamanoPagina;
        }
        return (
            <div className={"panel panel-success"}>
                <div className={"panel-heading"}>
                    <h2 className={"panel-title-white"}>
                        <span className="badge">{totalRegistros}</span> Registros encontrados
                    </h2>
                </div>
                <ReactTable data={registros}
                    columns={this.columns}
                    manual
                    defaultPageSize={numRegistros}
                    pageSizeOptions={this.calcularOpciones(numRegistros)}
                    page={paginaActual}
                    sortable={false}
                    resizable={false}
                    previousText={"Anterior"}
                    nextText={"Siguiente"}
                    loadingText={"Cargando..."}
                    noDataText={"No se ha encontrado información."}
                    pageText={"Página"}
                    ofText={"de"}
                    rowsText={""}
                    className={"-highlight -striped"}
                    pages={paginas}
                    onPageChange={(pageIndex) => {
                        this.consultarCambioPagina(tamanoPagina, pageIndex, tamanoPagina);
                    }}
                    onPageSizeChange={(pageSize, pageIndex) => {
                        this.consultarCambioPagina(pageSize, pageIndex, tamanoPagina);
                    }}
                />
            </div>
        );
    }

    consultarCambioPagina(pageSize: number, pageIndex: number, tamanoPagina: number) {
        const { filtro } = this.props;
        const filtroConsulta: FiltroConsultaReciboResumen = {
            dniEmpleador: filtro.dniEmpleador,
            fechaInicial: filtro.fechaInicial,
            fechaFinal: filtro.fechaFinal,
            servicio: filtro.servicio,
            estados: filtro.estados,
            consecutivoSolicitud: filtro.consecutivoSolicitud,
            codigoConsulta: CODIGOS_CONSULTA.CONSULTA_NOVEDADES_RESUMEN,
            dniUsuarioOperacion: filtro.dniUsuarioOperacion,
            tamanoPagina: pageSize ? pageSize : tamanoPagina,
            paginaActual: pageIndex
        };
        this.props.consultaPaginada(filtroConsulta);
    }

    calcularOpciones(tamanoPagina: number) {
        const arreglo = [10, 20, 25, 50, 100];
        const elemento = arreglo.find(valor => valor === tamanoPagina);
        if (elemento) {
            return arreglo;
        } else {
            return [...arreglo, tamanoPagina].sort((a, b) => { return a - b; });
        }
    }

    renderTexto = (props: any) => {
        if (props.value || !isNaN(props.value)) {
            if (props.value.length > 20) {
                const tooltip = (
                    <Tooltip id="tooltip" className="tooltip-pos" arrowOffsetTop={20}>{props.value}</Tooltip>
                );
                return (
                    <div style={{ marginTop: '10px' }}>
                        <OverlayTrigger placement="top" overlay={tooltip}>
                            <span>{props.value}</span>
                        </OverlayTrigger>
                    </div>
                );
            }
            return (
                <div style={{ marginTop: '10px' }}>
                    <span>{props.value}</span>
                </div>
            );
        }
        return (props.value);
    }

    renderDetalleJson = (props: any, stringJson: string) => {
        const subTitulo = `Consecutivo Respuesta: # ${props.original.consecutivo}`;
        return (
            <div style={{ marginTop: '5px' }}>
                <ModalDetalleJson
                    titulo={props.original.nombreServicio}
                    subTitulo={subTitulo}
                    stringJson={stringJson}
                />
            </div>
        );
    }
}

interface TablaConsultaResumenProps {
    registros: Array<ResumenNovedad>
    filtro: FiltroConsultaReciboResumen,
    paginas: number,
    tamanoPagina: number,
    paginaActual: number,
    totalRegistros: number,
    consultaPaginada?: (filtro: FiltroConsultaReciboResumen) => void;
}



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/recibo_novedades_resumen/componentes/TablaConsultaResumen.tsx